<template>
  <div id="newList">
    <div class="newlistCenter">
      <div class="ulCenter">
        <ul class="ul_Two">
          <li
            v-for="(item, index) in NewsNav"
            :key="item.id"
            @click="INDEX(index)"
            :class="{ active: index === curId }"
          >
            {{ item.columname }}
          </li>
        </ul>
      </div>
      <!-- 移动端标签栏 -->
      <div class="mpCenter">
        <van-tabs @click="onClick">
          <van-tab v-for="(item) in NewsNav" :title="item.columname" :key="item.id">
            
          </van-tab>
        </van-tabs>
      </div>
      <div
        class="imgList wow animated bounceInUp"
        data-wow-duration="1.5s"
        data-wow-delay=".5"
        data-wow-offset="0"
        v-for="item in showPage"
        :key="item.id"
      >
        <router-link
          :to="{ name: 'Details', params: { id: item.id, modular: 2 } }"
          tag="a"
          ><img v-lazy="item.images" alt=""
        /></router-link>
        <p class="p1">
          <router-link
            tag="a"
            :to="{ name: 'Details', params: { id: item.id, modular: 2 } }"
            :title="item.title"
          >
            {{ item.title }}</router-link
          >
        </p>
        <p class="p2">
          <router-link
            :to="{ name: 'Details', params: { id: item.id, modular: 2 } }"
            tag="a"
            :title="item.brief"
          >
            {{ item.brief }}</router-link
          >
        </p>
        <p class="p3">{{ item.addtime | formatDate }}</p>
      </div>
      <div class="block">
        <el-pagination
          layout="prev, pager, next"
          :page-size="Onepage"
          background
          :total="Number(num)"
          prev-text="<"
          next-text=">"
          :pager-count="5"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";
import router from "../../router/index";
import { GetColumn_List, GetHomePage_Two } from "@/https/http";
import { formatDate } from "@/js/data.js";
export default {
  data() {
    return {
      NewsList: "",
      NewList: "",
      NewsNav: "",
      curId: 0,
      cur: 1,
      num: "",
      totalPage: "",
      page: "",
      Onepage: 12,
      showPage: "",
      Two_Three: "",
    };
  },
  filters: {
    formatDate(time) {
      time = time * 1000;
      let date = new Date(time);
      return formatDate(date, "yyyy-MM-dd");
    },
  },
  methods: {
    onClick(name, title) {
      this.curId = name;
      console.log(title,name);
      GetColumn_List({
        column_id: this.NewsNav[this.curId].id,
        modular: 2,
      }).then((res) => {
        this.showPage = res.result.data;

        // this.num = res.result.data.length;
        this.NewsList = res.result.data;
        this.totalPage = Math.ceil(this.num / this.Onepage); //求总页数
        this.Page(this.cur);
      });
      
    },
    INDEX(x) {
      this.curId = x;
      this.Created();
      GetColumn_List({
        column_id: this.NewsNav[this.curId].id,
        modular: 2,
      }).then((res) => {
        this.showPage = res.result.data;

        // this.num = res.result.data.length;
        this.NewsList = res.result.data;
        this.totalPage = Math.ceil(this.num / this.Onepage); //求总页数
        this.Page(this.cur);
      });
    },
    // 获取分页
    Page(num) {
      this.cur = 1;
      this.cur = num; //当前页
      // var list = (this.cur - 1) * this.Onepage; //每去一组数据的第一个索引
      // this.showPage = this.NewsList.slice(list, list + this.Onepage); //从总数据中取出每页的数据
    },
    handleCurrentChange(cpage) {
      window.scrollTo({
        top: 500,
        behavior: "smooth",
      });
      this.cur = cpage;
      this.Created();
    },
    Created() {
      GetHomePage_Two({ column_id: this.$route.query.id }).then((res) => {
        this.NewsNav = res.result.data;
        GetColumn_List({
          column_id: this.NewsNav[this.curId].id,
          modular: 2,
          number: this.Onepage,
          page: this.cur,
        }).then((res) => {
          this.showPage = res.result.data;
          this.num = Number(res.result.totalRecords);
          this.totalPage = Math.ceil(this.num / this.Onepage); //求总页数
          this.Page(this.cur);
        });
      });
    },
  },
  created() {
    this.Created();
    // GetHomePage_Two({ column_id: this.$route.query.id }).then((res) => {
    //   this.NewsNav = res.result.data;
    //   console.log(res.result.data);
    //   GetColumn_List({
    //     column_id: this.NewsNav[this.curId].id,
    //     modular: 2,
    //     number: this.Onepage,
    //     page: this.cur,
    //   }).then((res) => {
    //     this.num = Number(res.result.totalRecords);
    //     this.NewsList = res.result.data;
    //     this.totalPage = Math.ceil(Number(this.num) / this.Onepage); //求总页数
    //     this.Page(this.cur);
    //   });
    // });
  },
  mounted() {
    window.addEventListener("scroll", this.windowScroll);
    this.$parent.color = `#000`;
    this.$parent.backgroundColor = "#fff";
    let wow = new WOW({
      boxClass: "wow", //需要执行动画的元素的 class
      animateClass: "animated", //animation.css 动画的 class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备上执行动画
      live: true, //异步加载的内容是否有效
    });
    wow.init();
    router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
      console.log(to, from, next);
    });
  },
};
</script>
<style lang="scss" >
ul {
  list-style: none;
}
@media screen and(min-width: 1020px){
  .ulCenter {
  width: 1440px;
  min-width: 1440px;
  margin: 0 auto;
}
.ul_Two {
  display: flex;
  float: right;
  margin-left: 1142px;
  height: 16px;
  li.active {
    color: #ff8229;
  }
  li :hover {
    color: #ff8229;
  }

  li.active {
    color: #ff8229;
  }
  li {
    width: 64px;
    height: 16px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 30px;
    margin-left: 63px;
    cursor: pointer;
  }
}
.imgList:hover {
  margin-bottom: -4px;
  border-bottom: 4px solid #ff6c04;
  .p1:hover {
    color: #ff6c04;
  }
}

#newList {
  width: 100%;
  .newlistCenter {
    width: 1440px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;

    .imgList {
      width: 347px;
      height: 479px;
      margin-left: 13px;
      margin-top: 31px;
      position: relative;
      img {
        width: 350px;
        height: 292px;
      }
      .p1 {
        width: 301px;
        height: 24px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-left: 21px;
      }
      .p1 > a {
        width: 301px;
        height: 18px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
        text-decoration: none;
      }
      .p1 > a:hover {
        color: #ff6c04;
        cursor: pointer;
      }
      .p2 {
        width: 306px;
        margin-left: 21px;
        /* -----------------------------文字换行----------------------------- */
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .p2 > a {
        width: 306px;
        height: 47px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 30px;
        cursor: pointer;
        text-decoration: none;
      }
      .p3 {
        /* width: 88px; */
        height: 14px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 23px;
        margin-left: 21px;
      }
      .Time {
        width: 89px;
        margin-left: 21px;
        height: 14px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 23px;
        cursor: pointer;
      }
    }
  }
  .block {
    margin: 0 auto;
    display: flex;
    justify-content: center;
    .el-pagination {
      height: 30px;
      display: flex;
      align-items: center;
      margin-top: 30px;
      margin-bottom: 30px;
      justify-content: center;
      .btn-prev,
      .btn-next {
        /* width: 50px !important;
        height: 21px !important; */
        width: 40px;
        height: 35px;
      }
      .btn-next {
        margin-left: 30px;
      }
      .el-pager {
        display: flex;
        list-style: none;
        .number {
          width: 20px;
          height: 20px;
          margin-left: 30px;
          text-align: center;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .number.active {
          width: 20px;
          height: 20px;
          background: #ff8229;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
}
.F {
  height: 34px;
  min-width: 1440px;
  margin-bottom: 148px;
  .F1Center {
    width: 1440px;
    min-width: 1440px;
    height: 34px;
    margin: 0 auto;
    .F1 {
      width: 34px;
      height: 34px;
      background: #ff8229;
      border-radius: 5px;
      p {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        line-height: 30px;
        text-align: center;
      }
    }
  }
}
.mpCenter{
  display:none;
}
}
@media screen and(max-width:1020px){
  .newlistCenter{
    width: 100%;
    display:flex;
    flex-wrap:wrap;
    box-sizing: border-box;
    padding-left:10px;
    padding-right:10px;
    justify-content: space-between;

    .ulCenter{
      display:none;
    }
    .mpCenter{
      width: 100%;
      height:70px;
    }
    .imgList{
      width: 49%;
      margin-bottom:25px;
      img{
        width:100%
      }
      .p1 {
        height: 24px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin:0;
        margin-top:10px;
        
      }
      .p1 > a {
        height: 18px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
        text-decoration: none;
      }
      .p1 > a:hover {
        color: #ff6c04;
        cursor: pointer;
      }
      .p2 {
        margin:0;
        margin-top:7px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .p2 > a {
        height: 47px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 30px;
        cursor: pointer;
        text-decoration: none;
      }
      .p3 {
        height: 14px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 23px;
        margin:0;
        margin-top:10px;
      }
      .Time {
        height: 14px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 23px;
        cursor: pointer;
      }
    }
  }
}

</style>